<template>
  <div id="cheat-sheet" class="cheat-sheet">
    <div class="container">
      <h1>Cheat Sheet</h1>

      <!-- table of content -->
      <p>Following topics are covered in this cheat sheet</p>
      <ul class="margin-bottom-xl">
        <li><a href="#colors">Colors</a></li>
        <li><a href="#typography">Typography</a></li>
        <li><a href="#spacing">Spacing</a></li>
        <li><a href="#html-tags">HTML Tags</a></li>
        <li><a href="#elements">elements</a></li>
      </ul>

      <h2 id="colors">Colors</h2>
      <div class="margin-bottom-xl">
        <p class="lead-text">Green Colors used for elements with action, pink colors used for decriptive elements.</p>
        <div class="color-card color-card--green-light"></div>
        <div class="color-card color-card--green-dark"></div>
        <div class="color-card color-card--red"></div>
        <div class="color-card color-card--pink"></div>
        <br />
        <div class="color-card color-card--gray-dark"></div>
        <div class="color-card color-card--gray-medium"></div>
        <div class="color-card color-card--gray-light"></div>
        <br />
        <div class="color-card color-card--gradient-green"></div>
        <div class="color-card color-card--gradient-red"></div>
      </div>

      <div class="flex-auto margin-bottom-xl">
        <div>
          <h2 id="typography">Typography</h2>
          <div class="typography-visualizer">
          <h1>H1 Lorem Ipsum</h1>
          <h2>H2 Lorem Ipsum</h2>
          <h3>H3 Lorem Ipsum</h3>
          <p class="lead-text">Lead text Lorem Ipsum Dolor sit Amet.</p>
          <h4>H4 Lorem Ipsum</h4>
          <p>Paragraph Lorem Ipsum</p>
          <p class="text-secondary"><strong>Bold Text secondary</strong></p>
          <p class="text-secondary">Normal Text secondary</p>
          </div>
        </div>
        <div>
          <h2 id="spacing">Spacing</h2>
          <p>For all spaces use the regarding classes:<br /> .margin-bottom-{spacing} and .padding-{spacing}</p>
          <p>Always space elements at there bottom.<br />
            For example between the page components, <br />
            use margin-bottom and not margin-top.<br />
            In normale spacing situations, never use margin-top.</p>
          <div class="spacing-visualizer spacing-visualizer--xl">$spacing-xl</div>
          <div class="spacing-visualizer spacing-visualizer--large">$spacing-large</div>
          <div class="spacing-visualizer spacing-visualizer--base">$spacing-base</div>
          <div class="spacing-visualizer spacing-visualizer--small">$spacing-small</div>
          <div class="spacing-visualizer spacing-visualizer--tiny">$spacing-tiny</div>
        </div> 
      </div>

      <h2 id="html-tags">HTML Tags</h2>
      <div class="flex-auto margin-bottom-xl">
        <div>
          <div class="margin-bottom-base">
            <h4>Buttons &amp; Links</h4>
            <div class="margin-bottom-base">
              <button class="btn btn-primary">Button Primary</button>&nbsp;&nbsp;
              <button class="btn btn-secondary">Button Secondary</button>&nbsp;&nbsp;
              <button class="btn btn-monospaced"><i class="material-icons">star</i></button>
            </div>
            <button class="btn btn-primary btn--large">Button Primary large</button>&nbsp;&nbsp;
            <button class="btn btn-secondary btn--large">Button Secondary large</button>&nbsp;&nbsp;
          </div>
          <div class="margin-bottom-base">
            <a href="#">Default Link</a>&nbsp;&nbsp;
            <a href="#" class="btn btn-read-more">Read More</a>
            <a href="#" class="btn btn-text-gradient-dark">gradient hover</a>
            <a href="#" class="btn btn-text-gradient-light">gradient hover</a>
          </div>
          <div>
            <a href="#" class="icon-link">
              <i class="material-icons">shopping_cart</i>
              <span>shopping</span>
            </a>
            <a href="#" class="icon-link">
              <i class="material-icons">restaurant</i>
              <span>restaurants</span>
            </a>
            <a href="#" class="icon-link"> 
              <i class="material-icons">hotel</i>
              <span>hotels</span>
            </a>
          </div>
        </div>
        <div>
          <h4>Chips</h4>
          <span class="chip">Top event</span>&nbsp;&nbsp;
          <span class="chip chip--borderless">borderless</span>&nbsp;&nbsp;
          <span class="chip"><i class="material-icons">date_range</i>27.4.2020</span>
        </div>
      </div>

      <h2 id="elements">Elements</h2>
      <h3>Cards</h3>
      <div class="grid-1-1">
        <a href="#" class="card card--h">
          <div class="card__image">
            <img src="https://i.picsum.photos/id/1037/400/400.jpg" alt="image of the krienser desert" />
          </div>
          <div class="card__body">
            <div class="card__chip-row">
              <span class="chip chip--borderless"><i class="material-icons">date_range</i>27.4.2020</span>
            </div>
            <div class="card__content">
              <h3>Lorem Ipsum Dolor</h3>
              <p class="lead-text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
            </div>
          </div>
          <div class="card__action">
            <a href="#" class="btn btn-primary btn--large">action!</a>
          </div>
        </a>

        <a href="#" class="card card--h">
          <div class="card__image">
            <img src="https://i.picsum.photos/id/1018/300/300.jpg" alt="image of the krienser desert" />
          </div>
          <div class="card__body">
            <div class="card__chip-row">
              <span class="chip chip--borderless"><i class="material-icons">date_range</i>27.4.2020</span>
            </div>
            <div class="card__content">
              <h3>Lorem Ipsum Dolor</h3>
              <p class="lead-text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
            </div>
          </div>
          <div class="card__action">
            <a href="#" class="btn btn-primary btn--large">action!</a>
          </div>
        </a>

        <a href="#" class="card card--h">
          <div class="card__image">
            <img src="https://i.picsum.photos/id/184/500/500.jpg" alt="image of the krienser desert" />
          </div>
          <div class="card__body">
            <div class="card__chip-row">
              <span class="chip chip--borderless"><i class="material-icons">date_range</i>27.4.2020</span>
            </div>
            <div class="card__content">
              <h3>Lorem Ipsum Dolor</h3>
              <p class="lead-text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
            </div>
          </div>
          <div class="card__action">
            <a href="#" class="btn btn-primary btn--large">action!</a>
          </div>
        </a>

        <a href="#" class="card card--h">
          <div class="card__image">
            <img src="https://i.picsum.photos/id/249/300/300.jpg" alt="image of the krienser desert" />
          </div>
          <div class="card__body">
            <div class="card__chip-row">
              <span class="chip chip--borderless"><i class="material-icons">date_range</i>27.4.2020</span>
            </div>
            <div class="card__content">
              <h3>Lorem Ipsum Dolor</h3>
              <p class="lead-text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
            </div>
          </div>
          <div class="card__action">
            <a href="#" class="btn btn-primary btn--large">action!</a>
          </div>
        </a>
      </div>

      <div class="grid-vertical-cards">
        <a href="#" class="card card--v card--skeleton">
          <div class="card__image">
            <img src="https://i.picsum.photos/id/1037/300/200.jpg" alt="image of the krienser desert" />
          </div>
          <div class="card__body">
            <div class="card__chip-row">
              <span class="chip chip--borderless"><i class="material-icons">date_range</i>27.4.2020</span>
            </div>
            <div class="card__content">
              <h3>Lorem Ipsum Dolor</h3>
              <p class="lead-text">aa Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
            </div>
          </div>
          <div class="card__action">
            <a href="#" class="btn btn-primary btn--large">action!</a>
          </div>
        </a>

        <a href="#" class="card card--v card--skeleton">
          <div class="card__body">
            <div class="card__chip-row">
              <span class="chip chip--borderless"><i class="material-icons">date_range</i>27.4.2020</span>
            </div>
            <div class="card__content">
              <h3>Lorem Ipsum Dolor</h3>
              <p class="lead-text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
            </div>
          </div>
          <div class="card__action">
            <a href="#" class="btn btn-primary btn--large">action!</a>
          </div>
        </a>

        <a href="#" class="card card--v card--skeleton">
          <div class="card__image">
            <img src="https://i.picsum.photos/id/249/300/200.jpg" alt="image of the krienser desert" />
          </div>
          <div class="card__body">
            <div class="card__chip-row">
              <span class="chip chip--borderless"><i class="material-icons">date_range</i>27.4.2020</span>
            </div>
            <div class="card__content">
              <h3>Lorem Ipsum Dolor</h3>
              <p class="lead-text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
            </div>
          </div>
          <div class="card__action">
            <a href="#" class="btn btn-primary btn--large">action!</a>
          </div>
        </a>
      </div>

      <div class="grid-vertical-cards">
        <a href="#" class="card card--v">
          <div class="card__image">
            <img src="https://i.picsum.photos/id/1037/300/200.jpg" alt="image of the krienser desert" />
          </div>
          <div class="card__body">
            <div class="card__chip-row">
              <span class="chip chip--borderless"><i class="material-icons">date_range</i>27.4.2020</span>
            </div>
            <div class="card__content">
              <h3>Lorem Ipsum Dolor</h3>
              <p class="lead-text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
            </div>
          </div>
          <div class="card__action">
            <a href="#" class="btn btn-primary btn--large">action!</a>
          </div>
        </a>

        <a href="#" class="card card--v">
          <div class="card__image">
            <img src="https://i.picsum.photos/id/1018/300/200.jpg" alt="image of the krienser desert" />
          </div>
          <div class="card__body">
            <div class="card__chip-row">
              <span class="chip chip--borderless"><i class="material-icons">date_range</i>27.4.2020</span>
            </div>
            <div class="card__content">
              <h3>Lorem Ipsum Dolor</h3>
              <p class="lead-text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
            </div>
          </div>
          <div class="card__action">
            <a href="#" class="btn btn-primary btn--large">action!</a>
          </div>
        </a>

        <a href="#" class="card card--v">
          <div class="card__image">
            <img src="https://i.picsum.photos/id/249/300/200.jpg" alt="image of the krienser desert" />
          </div>
          <div class="card__body">
            <div class="card__chip-row">
              <span class="chip chip--borderless"><i class="material-icons">date_range</i>27.4.2020</span>
            </div>
            <div class="card__content">
              <h3>Lorem Ipsum Dolor</h3>
              <p class="lead-text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.</p>
            </div>
          </div>
          <div class="card__action">
            <a href="#" class="btn btn-primary btn--large">action!</a>
          </div>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'CheatSheet',
  data () {
    return {
      
    }
  }
}
</script>